import React from 'react';
import { MessageCircle } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * ChatEmptyState - Welcome screen with suggestion buttons
 * Shown when chat has no messages
 */
export default function ChatEmptyState({ onSendSuggestion }) {
  const suggestions = [
    'What should I do next?',
    'What can I work on right now?',
    'Help me choose a task'
  ];

  return (
    <div style={{
      textAlign: 'center',
      color: '#666',
      marginTop: '40px'
    }}>
      <MessageCircle 
        size={48} 
        color={ABLE_COLORS.secondary} 
        style={{ margin: '0 auto 16px' }} 
      />
      <p>Hi! I can help you figure out what to work on right now.</p>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginTop: '16px',
        padding: '0 20px'
      }}>
        {suggestions.map((text) => (
          <button
            key={text}
            onClick={() => onSendSuggestion(text)}
            style={{
              padding: '12px',
              background: 'white',
              border: `2px solid ${ABLE_COLORS.secondary}`,
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              color: ABLE_COLORS.primary,
              fontWeight: '500',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = ABLE_COLORS.bg;
              e.currentTarget.style.borderColor = ABLE_COLORS.primary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.borderColor = ABLE_COLORS.secondary;
            }}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
}
